const doc = [({"da":({"js":({"components":({"user":({"admin":({"school_classes":({"edit":({"teachers_select":({"create_new_teacher":"Opret ny lærer", "teachers":"Lærere"})})})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;